// extracted by mini-css-extract-plugin
module.exports = {"order-details":"OrderDetails_order-details__2gAcf"};